<template>
	<button
		class="btn btn-block btn-default"
		@click="handleClicked"
		tabindex="1"
		:id="btnId"
		:disabled="disabled || loading"
		:class="{
			'disabled': disabled || loading,
			'btn-primary': btnPrimary,
			'hide': btnHide
		}">

		<div v-if="loading" class="loading">
			<div class="loadingLeft"><div></div></div>
			<div class="loadingRight"><div></div></div>
		</div>
		<span v-else>{{ label }}</span>
	</button>
</template>

<script>
export default {
	name: 'formButton',
	description: 'Basic button setting with spinner loading state, disable.. etc',
	props: {
		btnId: {
			type: String,
			default: '',
			note: 'Button ID'
		},
		btnPrimary: {
			type: Boolean,
			default: false,
			note: 'Primary CSS type'
		},
		btnHide: {
			type: Boolean,
			default: false,
			note: 'Button hide'
		},
		label: {
			type: String,
			default: '',
			note: 'Button text(label)'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Handling disabled state'

		},
		buttonClick: {
			type: Function,
			note: 'Function when it clicked'
		},
		loading: {
			type: Boolean,
			default: false,
			note: 'Loading state, when it true, spinner showing and label hide'
		}
	},
	methods: {
		handleClicked() {
			if (this.buttonClick) this.buttonClick();
		}
	}
};
</script>

<style scoped>
	button {
		text-transform: uppercase;
	}
</style>
